import React from "react";
// react plugin for creating charts
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import AccessTime from "@material-ui/icons/AccessTime";
import Refresh from "@material-ui/icons/Refresh";
import Edit from "@material-ui/icons/Edit";
import Tooltip from "@material-ui/core/Tooltip";
// core components
//import GridContainer from "components/Grid/GridContainer.js";
import ChartistGraph from "react-chartist";
//Matui not tim
import Grid from "@material-ui/core/Grid";
import GridItem from "components/Grid/GridItem.js";
import Button from "@material-ui/core/Button";
import Hidden from "@material-ui/core/Hidden";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
//import ApexChart from "views/Charts/ApexRadial.js";
//import Chart from "react-apexcharts";
import CardFooter from "components/Card/CardFooter.js";
//import styles from "assets/dashboardStyle.js";
//import axios from "axios";
import LineDemo from "./line.js";
//import items from "./MockData/dimensions.js";
// The bootstrap plain carousel Mighht be better,
// Start implementation changes here https://react-bootstrap.github.io/components/carousel/
//import Carousel from "react-elastic-carousel";
// Styles
import "./DashStyles/customStyles.css";
//import MatButton from "./DashStyles/materialButton.js";
//import { Menu, Dropdown } from "semantic-ui-react";
//import dimensionalData from "./MockData/dimensions.js";
import styles from "./DashStyles/dashboardStyle.js";
//import chartStyles from "assets/jss/material-dashboard-pro-react/views/chartsStyle.js";
// import Menu from "./DashStyles/Material_Menu.js";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
//import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import PropTypes from "prop-types";
// Accordian
import Collapse from "@material-ui/core/Collapse";
//import AccordionSummary from "@material-ui/core/AccordionSummary";
//import AccordionDetails from "@material-ui/core/AccordionDetails";
//import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import IconButton from "@material-ui/core/IconButton";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import Primary from "components/Typography/Primary.js";
import CardTabs from "./cardNav.js";
import DemoMobile from "./demoMobileLine.js";
import { dailySalesChart } from "./MockData/charts.js";

var delays = 80,
  durations = 500;
var delays2 = 80,
  durations2 = 500;

// To Do:

//Simplyfy
// Use existing matui & tim components-Appbar
// Visual appeal and less clutter
// Delete the rest/unused files
// Use one of Tims graphs for over time section

// Make backups of tables and then just use one of Tim's mobile responsive backgrounds

// Tab Panel Component
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3} style={{ fontFamily: "Arial" }}>
          {children}
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};
// index Component thingy
// assigns values "id" and "aria controls"
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
// ApexCharts: https://apexcharts.com/docs/chart-types/radialbar-gauge/
// ReactChartis2: https://github.com/jerairrest/react-chartjs-2

const useStyles = makeStyles(styles);

export default function Dashboard() {
  const classes = useStyles();
  // const [introOpen, setIntroOpen] = React.useState(true);
  const [open, setOpen] = React.useState(true);
  // const [activeItem, setActiveItem] = React.useState("Home");
  // const dimensions = React.useState(dimensionalData)[0];
  //const [selectedDimension, changeDimension] = React.useState(items[0]);
  // Menu Controllers
  //const [value, setValue] = React.useState(0);
  //const handleChange = (event, newValue) => { setValue(newValue);};
  // ApexChart options
  /* Removed API Call to server for Demo purposes */
  return (
    <div>
      <Grid spacing={2}>
        {/* Intro Card */}
        <GridItem xs={12}>
          <Card login className="card-default-bg">
            <CardHeader
              className={`${classes.cardHeader} ${classes.textCenter} card-default-header`}
              color="primary"
            >
              {" "}
              <div className={classes.typo}>
                <h4 className="managers-title">Employee Data Overview</h4>
              </div>
            </CardHeader>
            <CardBody style={{ paddingBottom: "0px" }}>
              <div className={`${classes.typo} responsive-p`}>
                <p>
                  <strong>Note</strong>: This Page represents a mock overview of
                  data managed by users of this web application. All sensitive
                  infomation has been replaced by placeholder data and text.
                </p>
                <Hidden xsDown>
                  <p>
                    The purpose of this demonstration is to showcase my
                    capabilities in the creation and development of React Web
                    Applications and does not reflect the data of the
                    application's users in any way.
                  </p>
                </Hidden>
              </div>

              <Hidden smDown>
                <div className={classes.typo}>
                  <p>
                    In the production version of this application these
                    dimensions gather and display data from the employee
                    accessed via the complementary wellness survey application.
                    This allows managers access to real time data on employee
                    wellness over several mental health dimensions. At risk
                    employees can then be recomended the appropriate help.
                  </p>
                </div>
              </Hidden>
            </CardBody>
          </Card>
        </GridItem>
        {/* Dimensions Card */}
        {/* Mobile: Remove header, Hide card, make simple card for xs sizes */}
        <GridItem xs={12}>
          <Hidden smDown>
            <Card className="display-charts-card">
              <CardTabs />
            </Card>
          </Hidden>
          <Hidden smUp>
            <Card chart className={classes.cardHover}>
              <CardHeader color="info" className={classes.cardHeaderHover}>
                <ChartistGraph
                  className="ct-chart-white-colors"
                  data={dailySalesChart.data}
                  type="Line"
                  options={dailySalesChart.options}
                  listener={dailySalesChart.animation}
                />
              </CardHeader>
              <CardBody>
                <div className={classes.cardHoverUnder}>
                  <Tooltip
                    id="tooltip-top"
                    title="Refresh"
                    placement="bottom"
                    classes={{ tooltip: classes.tooltip }}
                  >
                    <Button simple color="info" justIcon>
                      <Refresh className={classes.underChartIcons} />
                    </Button>
                  </Tooltip>
                  <Tooltip
                    id="tooltip-top"
                    title="Change Date"
                    placement="bottom"
                    classes={{ tooltip: classes.tooltip }}
                  >
                    <Button color="transparent" simple justIcon>
                      <Edit className={classes.underChartIcons} />
                    </Button>
                  </Tooltip>
                </div>
                <h4 className={classes.cardTitle}>
                  Dimensional Summary Over Time
                </h4>
                <p className={classes.cardCategory}>
                  <span className={classes.successText}>
                    <ArrowUpward className={classes.upArrowCardCategory} /> 55%
                  </span>{" "}
                  increase in wellness scores.
                </p>
              </CardBody>
              <CardFooter chart>
                <div className={classes.stats}>
                  <AccessTime /> updated 4 minutes ago
                </div>
              </CardFooter>
            </Card>
          </Hidden>
        </GridItem>

        {/* Dimensions over Time */}
        <Hidden smDown>
          <GridItem xs={12}>
            <div className="overview-container">
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => setOpen(!open)}
              >
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>

              <Collapse in={open} timeout="auto" unmountOnExit>
                <Card login className="card-default-bg">
                  <div
                    className={`${classes.divStyle}`}
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginBottom: 15,
                    }}
                  >
                    <h4 className="managers-title">Dimensions Over Time</h4>
                  </div>
                  <CardBody>
                    <LineDemo />
                  </CardBody>
                </Card>

                <div style={{ paddingLeft: "55px" }}>
                  <p>
                    * Click on the dimension labels to show or hide them. Hover
                    the mouse over data points to see its value.
                  </p>
                </div>
              </Collapse>
            </div>
          </GridItem>
        </Hidden>
        <Hidden mdUp xsDown>
          <GridItem xs={12}>
            <div className="overview-container">
              <IconButton
                aria-label="expand row"
                size="small"
                onClick={() => setOpen(!open)}
              >
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>

              <Collapse in={open} timeout="auto" unmountOnExit>
                <DemoMobile />

                <div style={{ paddingLeft: "55px" }}>
                  <p>
                    * Click on the dimension labels to show or hide them. Hover
                    the mouse over data points to see its value.
                  </p>
                </div>
              </Collapse>
            </div>
          </GridItem>
        </Hidden>
      </Grid>
    </div>
  );
}

/* Removed Code API/Server Reqs etc
 React.useEffect(() => {
    axios.post(`${apiURL}`, authData).then(
      (response) => {
      
        const newD = [...items];
        for (let i = 0; i < newD.length; i++) {
          newD[i].data.currentAverage = response.data.result[i];
          //console.log(newD);
        }
        setDimensions(newD);
      },
      (error) => {
        console.log(error);
      }
    );
  }, []);
  // Data for server Req


// Provide JWT token and id in req.body
/*
const JWT = localStorage.getItem("token");
const apiURL = "http://localhost:3000/api/dashboard-stats/employee-dimensions";
const authData = { id: localStorage.getItem("id") };
// add JWT token to ser Req header
axios.interceptors.request.use(
  (config) => {
    config.headers.authorization = `Bearer ${JWT}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


 <>
          <GridItem xs={12} style={{ display: "flex", flexWrap: "wrap" }}>
            <Card
              style={{
                boxShadow: "none",
                background: "#edf2f6",
                minHeight: 380,
                // paddingLeft: "20px",
                marginTop: 2,
                paddingBottom: 100,
               
              }}
            >
              {" "}
              <div style={{ display: "flex", flexWrap: "wrap" }}>
                <div
                  style={{
                    paddingTop: 82,
                    width: "40%",
                    margin: "auto",
                    height: "90%",
                  }}
                >
                  <div style={{ width: "90%" }}>
                    <ApexChart
                      hollow={"85%"}
                      // This color dynamic setting doesnt work
                      // ApexChart calcs color value on initial render
                      // When SelectedDimension changes series value will render again however..
                      // color remains static
                      colors={
                        ["#15a4fa"]
                      
                      }
                      dimension={selectedDimension.title}
                      series={[selectedDimension.data.currentAverage]}
                    />
                  </div>

                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Button
                      variant="outlined"
                      size="small"
                      style={{
                        fontFamily: "Verdana",
                        color: "#595959",
                        borderRadius: "30px",
                        background: "white",
                        fontSize: "12px",
                        fontWeight: 500,
                        textTransform: "none",
                      }}
                    >
                      {selectedDimension.title}
                    </Button>
                  </div>
                </div>
                <div
                  style={{
                    width: "50%",
                    height: "80%",
                    paddingTop: 50,
                    margin: "auto",
                    marginTop: 10,
                  }}
                >
                  <div className="mixed-chart">
                    <Chart
                      options={options}
                      series={selectedDimension.data.mockData}
                      type="bar"
                    />
                  </div>
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Button
                      variant="outlined"
                      size="small"
                      style={{
                        fontFamily: "Verdana",
                        color: "#595959",
                        borderRadius: "30px",
                        background: "white",
                        fontSize: "12px",
                        fontWeight: 500,
                        textTransform: "none",
                      }}
                    >
                      {selectedDimension.title + " Over Time"}
                    </Button>
                  </div>
                </div>
                <Card style={{ margin: "auto", margin: 10, marginTop: 30 }}>
                  <CardBody className={classes.cardBodyColor}>
                    <p
                      style={{
                        fontSize: "15px",
                        fontWeight: "500",
                        fontFamily: "Arial",
                      }}
                    >
                      {selectedDimension.description}
                    </p>
                  </CardBody>
                </Card>
              </div>
            </Card>
          </GridItem>
          ///// BLURB
            <div
                    style={{
                      paddingTop: "100px",
                      paddingBottom: "0px",
                      marginBottom: "0px",
                    }}
                  >
                    <div
                      className={classes.typo}
                      style={{
                        paddingBottom: "0px",

                        marginBottom: "0px",
                      }}
                    >
                      <p style={{ fontSize: "13px", paddingBottom: "0px" }}>
                        *Your data summaries. Click on a dimension to show its
                        detailed overview.
                      </p>
                    </div>
                  </div>
        </>



















*/
